package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class SelectionHeadersEnum(
    val key:String,
    val isNumeric:Boolean=false,
    val overflow:Boolean=true,
): TitleEnum {

    NUMBER(
        key = "",
    ),
    TEMPLATE(
        key = "name",
    ),
    MIN_QUANTITY(
        key = "minQuantity",
        isNumeric = true,
    ),
    MAX_QUANTITY(
        key = "maxQuantity",
        isNumeric = true,
    ),
    FIXED_QUANTITY(
        key = "code",
        overflow = true,
    ),
    QUANTITY(
        key = "amount",
        overflow = true,
    ),
    PRICE(
        key = "price",
        overflow = true,
    );

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                NUMBER -> strings.number
                TEMPLATE -> strings.template
                MIN_QUANTITY -> strings.minQuantity
                MAX_QUANTITY -> strings.maxQuantity
                FIXED_QUANTITY -> strings.fixedQuantity
                QUANTITY -> strings.quantity
                PRICE -> strings.price
            }
        }
}